import en from './en'; // english
import hi from './hi'; // hindi
import es from './es'; // spanish

const appLanguage = { en, hi, es };

export default appLanguage;
